import React, { lazy, Suspense, FunctionComponent, Component } from 'react';
import { Switch, Route, Redirect, RouteProps } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { AppStyle } from './components/app/appStyle';
import { Auth, AuthenticatedUser } from './lib/cognito';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './components/route/protected-route';

export const ROUTE_HOME = '/';
export const ROUTE_LOGIN = '/login';
export const ROUTE_PASSWORD = '/passwort/';
export const ROUTE_PASSWORD_RESET = '/passwort/:token/:username';
export const ROUTE_MANAGER = '/kanzlei/:tab';
export const ROUTE_MANAGER_SINGLE = '/kanzleien/:managerId/:tab';
export const ROUTE_MANAGERS = '/kanzleien';
export const ROUTE_ACCOUNTS = '/kunden';
export const ROUTE_ACCOUNT_SINGLE = '/kunden/:accountId/:tab';
export const ROUTE_DASHBOARD = '/dashboard';

export const SECTION_ACCOUNT_PROFILE = 'profile';
export const SECTION_ACCOUNT_USERS = 'benutzer';
export const SECTION_ACCOUNT_RECEIPTS = 'belege';
export const SECTION_ACCOUNT_DOCUMENTS = 'dokumente';
export const SECTION_ACCOUNT_CATEGORIES = 'kategorien';
export const SECTION_ACCOUNT_SETTINGS = 'settings';

export const PATH_ACCOUNT_SINGLE_RECEIPTS = `/kunden/:accountId/${SECTION_ACCOUNT_RECEIPTS}`;
export const PATH_ACCOUNT_SINGLE_PROFILE = `/kunden/:accountId/${SECTION_ACCOUNT_PROFILE}`;
export const PATH_ACCOUNT_SINGLE_DOCUMENTS = `/kunden/:accountId/${SECTION_ACCOUNT_DOCUMENTS}`;
export const PATH_ACCOUNT_SINGLE_USERS = `/kunden/:accountId/${SECTION_ACCOUNT_USERS}`;
export const PATH_ACCOUNT_SINGLE_CATEGORIES = `/kunden/:accountId/${SECTION_ACCOUNT_CATEGORIES}`;
export const PATH_ACCOUNT_SINGLE_SETTINGS = `/kunden/:accountId/${SECTION_ACCOUNT_SETTINGS}`;

// Managers
export const SECTION_MANAGER_USERS = 'benutzer';
export const SECTION_MANGER_USERS = 'benutzer';
export const SECTION_MANGER_PROFILE = 'profile';

export const PATH_MANGER_SINGLE_USERS = `/kanzleien/:managerId/${SECTION_MANGER_USERS}`;
export const PATH_MANAGER_SINGLE_PROFILE = `/kanzleien/:managerId/${SECTION_MANGER_PROFILE}`;

//TODO: remove?
export const PATH_MANAGER_USERS = `/kanzlei/${SECTION_MANAGER_USERS}`;

export const ROUTE_ACCOUNT_DASHBOARD = '/kunde/:accountId/dashboard';
export const ROUTE_DOCUMENTS = '/kunde/:accountId/dokumente';
export const ROUTE_RECEIPTS = '/kunde/:accountId/belege';

export const ROUTE_RECEIPTS_CATEGORY = `/kunde/:accountId/belege/:categorySlug/`;
export const ROUTE_RECEIPTS_CATEGORY_PERIOD = `/kunde/:accountId/belege/:categorySlug/:periodSlug`;

export const PATH_RECEIPTS_UNSORTED = `/kunde/:accountId/belege/unsorted`;

export const PATH_ACCOUNT_SETTINGS = '/kunde/:accountId/einstellungen';

export const ROUTE_USERS = '/kunde/:accountId/benutzer';
export const ROUTE_SETTINGS = '/kunde/:accountId/settings';
export const ROUTE_PROFILE_ACCOUNT = '/kunde/:accountId/profile';
export const ROUTE_PROFILE = '/profile';

const AsyncHomePage = lazy(() => import('./pages/home'));
const AsyncLoginPage = lazy(() => import('./pages/login'));
const AsyncPasswordPage = lazy(() => import('./pages/password'));
const AsyncReceiptsPage = lazy(() => import('./pages/receipts/'));
const AsyncDocumentsPage = lazy(() => import('./pages/documents/'));
const AsyncManagersPage = lazy(() => import('./pages/managers/'));
const AsyncAccountsPage = lazy(() => import('./pages/accounts/'));
const AsyncManagerPage = lazy(() => import('./pages/manager/'));
const AsyncSettingsPage = lazy(() => import('./pages/settings'));
const AsyncProfilePage = lazy(() => import('./pages/profile'));
const AsyncDashboardPage = lazy(() => import('./pages/dashboard'));

interface LinkParams {
  [key: string]: string;
}

export function getLink(route: string, params: LinkParams): string {
  return Object.keys(params).reduce(
    (url, key) => url.replace(':' + key, params[key]),
    route,
  );
}

const AppView: FunctionComponent = ({ children }) => {
  return (
    <div className="app">
      {children}
      <AppStyle />
    </div>
  );
};

interface HomeProps extends RouteProps {
  isAuthenticated: boolean;
  authenticationPath: string;
  user?: AuthenticatedUser;
}

class HomeRoute extends React.Component<HomeProps> {
  render() {
    const { user, isAuthenticated } = this.props;

    let redirect = getLink(ROUTE_SETTINGS, {});

    if (
      user &&
      user.systemUser &&
      user.systemUser.accounts &&
      user.systemUser.accounts[0]
    ) {
      console.log('user.systemUser.accounts', user.systemUser.accounts[0].id);
      redirect = getLink(ROUTE_RECEIPTS, {
        accountId: user.systemUser.accounts[0].id,
      });
    }
    if (user && user.managerId) redirect = getLink(ROUTE_ACCOUNTS, {});
    return (
      <Route
        {...this.props}
        render={(props) =>
          isAuthenticated ? (
            <Redirect
              to={{ pathname: redirect, state: { from: this.props.location } }}
            />
          ) : (
            <Redirect
              to={{
                pathname: ROUTE_LOGIN,
                state: { from: this.props.location },
              }}
            />
          )
        }
      />
    );
  }
}

const Loading = () => null;

export class Routes extends Component {
  state: {
    isAuthenticated: boolean;
    authenticating: boolean;
    user?: AuthenticatedUser;
  } = { isAuthenticated: false, authenticating: true, user: undefined };
  onLoginSuccess = async (user: AuthenticatedUser) => {
    this.setUser(user);
    //this.props.history.push(getLink(ROUTE_HOME,{}))
  };
  setUser = (user: AuthenticatedUser) => {
    let isAuthenticated = false;
    if (user && (user.userId || user.managerId)) {
      isAuthenticated = true;
    }
    this.setState({
      user,
      authenticating: false,
      isAuthenticated,
    });
  };
  async componentDidMount() {
    const user = await Auth.getUser();
    this.setUser(user);

    console.log('router props', this.props, user);
  }
  render() {
    const { isAuthenticated, authenticating, user } = this.state;
    return (
      <AppView>
        {/* Global Error handling */}
        <ToastContainer position={'bottom-right'} limit={1} />
        <Suspense fallback={<Loading />}>
          {!authenticating && (
            <Switch>
              <HomeRoute
                authenticationPath={ROUTE_LOGIN}
                isAuthenticated={isAuthenticated}
                user={user}
                exact
                path={ROUTE_HOME}
              />

              <Route
                exact
                path={ROUTE_LOGIN}
                render={(props) => (
                  <AsyncLoginPage
                    onLoginSuccess={this.onLoginSuccess}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={ROUTE_PASSWORD}
                render={(props) => <AsyncPasswordPage {...props} />}
              />
              <Route
                path={ROUTE_PASSWORD_RESET}
                render={(props) => <AsyncPasswordPage {...props} />}
              />

              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact
                path={ROUTE_ACCOUNT_DASHBOARD}
                render={(props) => (
                  <AsyncDashboardPage
                    user={user}
                    accountId={props.match.params.accountId}
                  />
                )}
              />

              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact
                path={ROUTE_RECEIPTS}
                render={(props) => <AsyncReceiptsPage {...props} />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact
                path={ROUTE_RECEIPTS_CATEGORY}
                render={(props) => <AsyncReceiptsPage {...props} />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                path={ROUTE_RECEIPTS_CATEGORY_PERIOD}
                render={(props) => <AsyncReceiptsPage {...props} />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                path={ROUTE_DOCUMENTS}
                render={(props) => <AsyncDocumentsPage {...props} />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact
                path={ROUTE_MANAGERS}
                render={(props) => <AsyncManagersPage {...props} />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact
                path={ROUTE_MANAGER_SINGLE}
                render={(props) => <AsyncManagersPage {...props} />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact
                path={ROUTE_ACCOUNTS}
                render={() => <AsyncAccountsPage />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact
                path={ROUTE_DASHBOARD}
                render={() => <AsyncDashboardPage user={user} />}
              />

              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                path={ROUTE_ACCOUNT_SINGLE}
                render={(props) => <AsyncAccountsPage {...props} />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact={true}
                path={ROUTE_MANAGER}
                render={() => <AsyncManagerPage />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact={true}
                path={ROUTE_SETTINGS}
                render={(props) => <AsyncSettingsPage {...props} />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact={true}
                path={ROUTE_PROFILE}
                render={(props) => <AsyncProfilePage {...props} />}
              />
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                authenticationPath={ROUTE_LOGIN}
                exact={true}
                path={ROUTE_PROFILE_ACCOUNT}
                render={(props) => <AsyncProfilePage {...props} />}
              />
              {/* Catch all route */}
              <Route render={() => <Redirect to="/" />} />
              {/* TODO: create some helper method to make async loading cleaner */}
            </Switch>
          )}
        </Suspense>
      </AppView>
    );
  }
}
